import React from 'react';
import DetailPage from './DetailPage';
import DetailPageHero from './DetailPageHero';
import DetailPageParagraph from './DetailPageParagraph';

const DetailPageAppStoreWeb = () => {
  return (
    <DetailPage 
      title="App Store on the Web"
      heroSrc={'/images/app-store-web/hero.png'}
      content="The App Store on the Web brings the full App Store experience to browsers, making it accessible to users across all platforms. This project represents a significant step forward in making app discovery and installation seamless, regardless of the device or operating system. I was the sole designer leading this project across all platforms."
      year="2025"
      duration="2025 – 2026"
      role="Lead Designer"
    >
        <DetailPageHero 
            src="/images/app-store-web/Games.png" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageParagraph>
            The Games section brings together the best gaming experiences, from casual games to immersive adventures, all accessible through a unified interface.
        </DetailPageParagraph>

        <DetailPageHero 
            src="/images/app-store-web/Nav.png" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageParagraph>
            The navigation system provides seamless access to all sections of the App Store, making it easy for users to discover apps, games, and content across different categories.
        </DetailPageParagraph>

        <DetailPageHero 
            src="/images/app-store-web/TodayPage.png" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageHero 
            src="/images/app-store-web/TodayPage2.png" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageParagraph>
            The Today page showcases featured content, editor's picks, and daily highlights, providing users with curated recommendations and the latest app discoveries.
        </DetailPageParagraph>

        <DetailPageHero 
            src="/images/app-store-web/Arcade.png" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageParagraph>
            Apple Arcade subscribers can easily access their subscription benefits and explore the curated collection of premium games without ads or in-app purchases.
        </DetailPageParagraph>

        <DetailPageHero 
            src="/images/app-store-web/Categories.png" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageParagraph>
            Browse apps by category to find exactly what you're looking for, whether it's productivity tools, creative apps, entertainment, or utilities.
        </DetailPageParagraph>

        <DetailPageHero 
            src="/images/app-store-web/Charts.png" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageParagraph>
            Discover the most popular apps and games through top charts, featuring the highest-rated and most-downloaded content across all categories.
        </DetailPageParagraph>

        <DetailPageHero 
            src="/images/app-store-web/UniversalSearch.png" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageParagraph>
            Universal search makes finding apps, games, and content effortless, with intelligent suggestions and instant results across the entire App Store.
        </DetailPageParagraph>

        <DetailPageHero 
            src="/images/app-store-web/ProductPage.png" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageParagraph>
            Each app's product page provides comprehensive information, screenshots, reviews, and ratings, helping users make informed decisions before downloading.
        </DetailPageParagraph>

        <DetailPageHero 
            src="/images/app-store-web/Responsiveness.png" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageParagraph>
            The App Store on the Web is fully responsive, providing an optimal experience across all devices and screen sizes, from mobile phones to desktop computers.
        </DetailPageParagraph>
        
    </DetailPage>
  );
};

export default DetailPageAppStoreWeb;

